<template lang="pug">
#resultado-pesquisa-accordion
    .header(@click='click')
        h5 CPR {{ cpr.numero }}
        .right
            h5 {{ cpr.areaMonitoradaHa.toFixed(2).replace(/[.,]00$/, '') }} ha
            i.mdi.mdi-chevron-right(v-show='!isOpen')
            i.mdi.mdi-chevron-down(v-show='isOpen')
    .content(v-if='isOpen')
        .matricula(
            v-for='matricula in cpr.matriculas',
            :key='matricula.id',
            @click='selecionarAreaMonitorada(matricula.id)'
        )
            h5.numero-matricula Matrícula {{ matricula.numero }}
            .right
                h5 {{ matricula.areaMonitorada.areaHa.toFixed(2).replace(/[.,]00$/, '') }} ha
                i.mdi.mdi-chevron-right
</template>

<script>
export default {
    name: 'ResultadoPesquisaAccordion',

    props: {
        cpr: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isOpen: false
        };
    },

    methods: {
        click() {
            this.isOpen = !this.isOpen;
            this.$emit('click');
        },

        selecionarAreaMonitorada(idAreaMonitorada) {
            this.$router.push({
                name: 'Área monitorada',
                params: { idAreaMonitorada }
            });
        }
    }
};
</script>

<style scoped lang="scss">
#resultado-pesquisa-accordion {
    user-select: none;
    .header {
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        height: 35px;
        align-items: center;
        padding: 0 10px;
    }

    .content {
        background-color: var(--default-background-color);

        .area-monitorada {
            display: flex;
            justify-content: space-between;
            height: 35px;
            align-items: center;
            padding: 0 10px 0 20px;
            border-bottom: 1px solid var(--default-border-color);
            cursor: pointer;

            .numero-area-monitorada {
                color: var(--primary);
            }
        }

        .area-monitorada:last-child {
            border-bottom: none;
        }

        .area-monitorada:first-child {
            border-top: 1px solid var(--default-border-color);
        }
    }

    .right {
        display: flex;

        & > h5 {
            margin-right: 20px;
        }

        i {
            color: var(--primary);
        }
    }
}
</style>
